import type { AiBusinessCenterModule } from '../types'

/** SRM供应采购独立应用配置。 */
export const srmModule: AiBusinessCenterModule = {
  key: 'srm',
  label: 'SRM供应采购',
  desc: '供应商准入/资质评估/询比价/采购订单/到货质检/对账结算',
  path: '/srm',
  homePath: '/srm/supplier',
  icon: 'ep:shopping',
  color: '#0ea5e9'
}
